<script setup lang="ts">
import { useTheme } from 'vuetify'
// import ScrollToTop from '@base/@core/components/ScrollToTop.vue'
import initCore from '@base/@core/initCore'
import { initConfigStore, useConfigStore } from '@base/@core/stores/config'
import { hexToRgb } from '@base/@core/utils/colorConverter'
import { onMounted } from 'vue'

// 只在开发环境中初始化 eruda

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()

// const { isMobile } = useDevice()
const { global } = useTheme()

// 移除 Firebase 消息处理，因为这是纯展示项目
// onMounted(() => {
//   eruda.init()
// })


</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <NuxtLoadingIndicator />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
      <!-- 阿里云监控脚本 -->
      <!-- <ScrollToTop /> -->
    </VApp>
  </VLocaleProvider>
</template>

<style lang="scss">
// @media (max-width: 1080px) {
//   html {
//     font-size: calc(100vw / 108); /* 1080px 屏宽时 = 10px */
//   }
// }

// @media (max-width: 768px) {
//   html {
//     font-size: calc(100vw / 37.5); /* 375px 屏宽时 = 10px */
//   }
// }</style>
